export default __webpack_public_path__ + "static/media/listor7.09f1640a.png";